import {
  PublicClientApplication,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";
import { KEY } from "../constants/common.const";

let msalInstance = null;

const getTenantConfigs = () => {
  const configs = {};
  // Add tenant configurations from environment variables
  //shi-g
  if (process.env.REACT_APP_DOMAIN_1) {
    configs[process.env.REACT_APP_DOMAIN_1] = {
      clientId: process.env.REACT_APP_CLIENT_ID_1,
      tenantId: process.env.REACT_APP_TENANT_ID_1,
    };
  }
  //shi-ev
  if (process.env.REACT_APP_DOMAIN_2) {
    configs[process.env.REACT_APP_DOMAIN_2] = {
      clientId: process.env.REACT_APP_CLIENT_ID_2,
      tenantId: process.env.REACT_APP_TENANT_ID_2,
    };
  }
  return configs;
};
export const getAllowedDomains = () => {
  return Object.keys(tenantConfigs);
};

export const tenantConfigs = getTenantConfigs();
const defaultClientId = process.env.REACT_APP_DEFAULT_CLIENT_ID;
const defaultTenantId = process.env.REACT_APP_DEFAULT_TENANT_ID;

export const config = {
  backendEndpoint: "https://utksapi-staging2.shi-ev.com/api/office/",
  defaultEndpoint: "https://utksapi-staging2.shi-ev.com/api/office/",
  clientEndpoint: "https://utks-staging2.shi-ev.com",
  clientId: defaultClientId,
  tenantId: defaultTenantId,
  timeoutDefault: 600000,
};

const getDomainFromEmail = (email) => {
  if (typeof email === "string" && email.includes("@")) {
    return email.split("@")[1].toLowerCase();
  }
  return null;
};

const createMsalConfig = (email) => {
  const domain = getDomainFromEmail(email);
  const tenantConfig = (domain && tenantConfigs[domain]) || {
    clientId: config.clientId,
    tenantId: config.tenantId,
  };
  return {
    auth: {
      clientId: tenantConfig.clientId,
      authority: `https://login.microsoftonline.com/${tenantConfig.tenantId}`,
      redirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  };
};

export const initMsalOnce = (email) => {
  const msalConfig = createMsalConfig(email);
  const prevConfigStr = localStorage.getItem("msalConfig");
  let shouldInit = true;

  if (prevConfigStr) {
    try {
      const prevConfig = JSON.parse(prevConfigStr);
      if (
        prevConfig.auth &&
        prevConfig.auth.clientId === msalConfig.auth.clientId &&
        prevConfig.auth.authority === msalConfig.auth.authority
      ) {
        shouldInit = false;
      }
    } catch {
      // ignore parse error, will re-init
    }
  }

  if (shouldInit || !msalInstance) {
    localStorage.setItem("msalConfig", JSON.stringify(msalConfig));
    msalInstance = new PublicClientApplication(msalConfig);
  }
  return msalInstance;
};

export const getLoginRequest = () => {
  const configStr = localStorage.getItem("msalConfig");
  if (!configStr) {
    return {
      scopes: [`${defaultClientId}/.default`],
    };
  }
  const config = JSON.parse(configStr);
  return {
    scopes: [`${config.auth.clientId}/.default`],
  };
};

export const getMsalInstance = () => {
  if (!msalInstance) {
    const stored = localStorage.getItem("msalConfig");
    const msalConfig = stored ? JSON.parse(stored) : createMsalConfig();
    if (!stored) {
      localStorage.setItem("msalConfig", JSON.stringify(msalConfig));
      clearMsalCache()
      window.location.href  = "/login"
    }
    msalInstance = new PublicClientApplication(msalConfig);
  }
  return msalInstance;
};

export const getToken = async () => {
  const msalInstance = getMsalInstance();
  const accounts = msalInstance.getAllAccounts();

  const loginRequest = getLoginRequest();

  if (accounts.length === 0) {
    await msalInstance.loginRedirect(loginRequest);
    return null;
  }

  const request = {
    ...loginRequest,
    account: accounts[0],
  };
  try {
    const response = await msalInstance.acquireTokenSilent(request);
    return response.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect(request);
    } else {
      throw error;
    }
  }
};

// export const adalConfig = {
//   tenant: "adfs",
//   clientId: config.clientId,
//   redirectUri: config.clientEndpoint,
//   postLogoutRedirectUri: config.clientEndpoint,
//   instance: "https://evgfs.shi.co.jp/",
//   endpoints: {
//     api: config.defaultEndpoint,
//   },
//   cacheLocation: "localStorage",
// };

// export const authContext = new AuthenticationContext(adalConfig);

// async function getNewToken() {
//   let token = authContext.getCachedToken(adalConfig.clientId);
//   if (token === null) {
//     token = await adalGetToken(authContext, adalConfig.clientId);
//   }
//   return token;
// }

// export const getToken = getNewToken;

// export const getUser = () => authContext.getCachedUser();
export function clearMsalCache() {
  Object.keys(localStorage)
.filter(key =>
  key.includes('windows.net') ||
  key.includes('msal."') ||

  key.includes('microsoftonline.com') ||
  key.includes('onmicrosoft.com') ||
  key.match(/[0-9a-fA-F\-]{36}\./)
)
.forEach(key => localStorage.removeItem(key));
}
export const logOut = () => {
  const msalInstance = getMsalInstance();

  const account =
    msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  localStorage.removeItem("msalConfig");
  clearMsalCache()
  // Helpful hints so the IdP ends the right session:
  msalInstance.logoutRedirect({
    account,
    logoutHint: account ? account.username : undefined,
    postLogoutRedirectUri: "/",
  });
};

export const toyotaKamoId = 23001;
export const arrayClInputDate = [636,639,642];
export const yuniId = 1002;
export const workingSaveStatus = [2,3]
export const nagatoId = 35001
export const hanmagunoId = 16001;
export const misawaId = 2005

export const goshogawara = 2004;
export const iwanai = 1001;
export const hayama = 9999; // TODO
